import Vue from "vue";
import Router from "vue-router";
import Reservation from "@/components/Reservation";
import SearchResult from "@/components/SearchResult";
import CityRanking from "@/components/CityRanking";
import accountContainer from "@/components/account/accountContainer";
import userJourneyContainer from "@/components/userJourney/userJourneyContainer";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: __dirname,
    routes: [
        {
            path: "/:lang?",
            component: {
                template: "<router-view></router-view>"
            },
            children: [
                {
                    path: "user-journey/",
                    name: "user-journey",
                    component: userJourneyContainer
                },
                {
                    path: "profile",
                    name: "profile",
                    component: accountContainer
                },
                {
                    path: "portfolio",
                    name: "portfolio",
                    component: accountContainer
                },
                {
                    path: "manage",
                    name: "manage",
                    component: accountContainer
                },
                {
                    path: "investment-planner",
                    name: "investment-planner",
                    component: accountContainer
                },
                {
                    path: "properties",
                    name: "properties",
                    component: accountContainer
                },
                {
                    path: "real-estate/:regionName/",
                    name: "real-estate",
                    component: SearchResult
                },
                {
                    path: "reservation/:project_id",
                    name: "reservation",
                    component: Reservation
                },
                {
                    path: "global-market-rankings",
                    name: "ranking",
                    component: CityRanking
                },

                // Legacy
                {
                    path: "projects/:regionName?",
                    name: "projects",
                    component: SearchResult
                },
                {
                    path: "ranking",
                    name: "ranking",
                    component: CityRanking
                }
                // {
                //   path: "*",
                //   name: "404",
                //   component: "<p>Page Not Found</p>"
                // },
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    // i18n.locale = to.params.lang || 'en';
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js